var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


$(document).ready(function(){
  if($('.announcement-slider').length > 0){
$('.announcement-slider').slick({
  dots: false,
  infinite: true,
    speed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
   arrows: false,
  autoplay:true
});
  }
  
if($('.testimonial_slider').length > 0){
  $('.testimonial_slider').slick({
  dots: true,
  infinite: true,
  autoplaySpeed: 0,
  speed: 5000,
  slidesToShow: 4,
  slidesToScroll: 3,
  arrows: false,
  adaptiveHeight: true,
  autoplay:false,
  responsive: [
  {
    breakpoint: 1140,
    settings: {
      slidesToShow: 2,
      slidesToScroll:2,
      infinite: true,
      dots: false
    }
  },
  {
    breakpoint: 575,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
  ]
  });
  
}
                  
if($('.home_testimonial_slider').length > 0){
$('.home_testimonial_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
}
  
$(".home_testimonial_slider .video_pop span.vid_icon").click(function(){
  $(this).parents(".block").find(".video_pop").addClass("active");
});
  
  });